import styled, { css } from 'styled-components'

export const Outer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;
`;

export const Card = styled.div`
    padding: 15px;
    border-radius: 3px;
    ${props => props.shadow && css`
        box-shadow: 0px 1px 10px rgb(0,0,0,0.1);
    `}
    ${props => props.border && css`
        border: 1px solid #E9EAEC;
    `}
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: ${props => props.maxWidth};
    margin: ${props => props.margin};
    border: ${props => props.border};
    justify-content: ${props => props.justifyContent};

    form {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

    @media (max-width: 510px) {
        width: calc(100vw - 60px);
    }
`;

export const Header = styled.div`
    font-weight: 500;
    font-size: 18px;
`;

export const FlexRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: ${props => props.wrap};
    justify-content: ${props => props.justifyContent};
    align-items: ${props => props.alignItems};
    margin: ${props => props.margin};

    @media (max-width: 510px) {
        flex-direction: column;

        ${props => props.wrap === 'nowrap' && css`
            flex-direction: row;
        `}
    }
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LineItem = styled.div`
    margin-top: 15px;
`;

export const SubHead = styled.div`
    color: grey;

    ${props => props.margin && css`
        margin: ${props => props.margin};
    `}
`;